import { StateInterface } from 'client/Interfaces/StateInterface'
import { formatCurrency } from 'client/Other/functions/currencyFormatter'
import { formatDate } from 'client/Other/functions/dateFunctions'
import { longDateSelector, longDateTimeSelector } from 'client/reducers/settings'
import { useCallback } from 'react'
import { useSelector } from 'react-redux'

interface IUseFormats {
  formatDateString: (date: string) => string
  formatDateTime: (date: string) => string
  getCurrencyFormattedValue: (value: number, options: { currency?: string | number; withSign?: boolean }) => string
}

const useFormats = (): IUseFormats => {
  const { locale, userCurrency, dateFormat, dateTimeFormat } = useSelector((state: StateInterface) => ({
    locale: state.token.locale,
    userCurrency: state.company.currencyId,
    dateFormat: longDateSelector(state),
    dateTimeFormat: longDateTimeSelector(state),
  }))

  const formatDateString: IUseFormats['formatDateString'] = useCallback(
    (date) => {
      return date ? formatDate(date, dateFormat, locale.split('_')[0]) : ''
    },
    [dateFormat, locale],
  )

  const formatDateTime: IUseFormats['formatDateTime'] = useCallback(
    (date) => {
      return date ? formatDate(date, dateTimeFormat, locale.split('_')[0]) : ''
    },
    [dateTimeFormat, locale],
  )

  const getCurrencyFormattedValue: IUseFormats['getCurrencyFormattedValue'] = useCallback(
    (value, { currency = userCurrency, withSign = true }) => {
      return formatCurrency(value, locale, currency, withSign)
    },
    [locale, userCurrency],
  )

  return { formatDateString, formatDateTime, getCurrencyFormattedValue }
}

export default useFormats
